var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 292,
    viewBox: "0 0 439 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8767 291.271H422.943",
    stroke: "#C3DBE6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4133 104.349C87.2018 97.247 95.8645 77.0691 88.7622 59.2807C81.6598 41.4923 61.4819 32.8295 43.6935 39.9318C25.9051 47.0342 17.2423 67.2121 24.3446 85.0005C31.447 102.789 51.6249 111.452 69.4133 104.349Z",
    fill: "#C3DBE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3968 76.9073C88.0178 60.9825 77.233 45.9481 61.3082 43.3271C45.3834 40.706 30.349 51.4908 27.728 67.4156C25.107 83.3404 35.8918 98.3748 51.8166 100.996C67.7414 103.617 82.7757 92.8321 85.3968 76.9073Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4533 89.0475C82.7858 79.7149 82.7858 64.5839 73.4533 55.2514C64.1208 45.9188 48.9898 45.9188 39.6572 55.2514C30.3247 64.5839 30.3247 79.7149 39.6572 89.0475C48.9898 98.38 64.1208 98.38 73.4533 89.0475Z",
    fill: "#C3DBE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1472 73.8837C68.1002 68.0416 64.1368 62.5332 58.2947 61.5802C52.4526 60.6272 46.9442 64.5907 45.9912 70.4327C45.0382 76.2748 49.0017 81.7833 54.8437 82.7362C60.6858 83.6892 66.1943 79.7258 67.1472 73.8837Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7087 77.3725C61.5984 76.1828 62.9765 72.8759 61.7868 69.9862C60.5971 67.0966 57.2902 65.7185 54.4006 66.9082C51.5109 68.0978 50.1328 71.4048 51.3225 74.2944C52.5121 77.1841 55.8191 78.5622 58.7087 77.3725Z",
    fill: "#C3DBE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7544 98.5582L8.69531 101.421L13.0222 102.752L18.0813 99.8896L13.7544 98.5582Z",
    fill: "#A2C5D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0165 104.283L11.9574 107.212L13.0225 102.752L18.0816 99.8893L17.0165 104.283Z",
    fill: "#A2C5D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8193 101.753C14.3533 100.954 19.2793 97.3591 26.868 93.0322C34.5232 88.7053 45.6399 84.3119 45.6399 84.3119C45.6399 84.3119 36.1874 91.5677 28.5321 95.8946C20.8769 100.221 15.2852 102.551 14.8193 101.753Z",
    fill: "#A2C5D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0219 102.752C15.6846 101.088 18.3473 99.4901 21.0766 97.8925C23.7393 96.2949 26.4685 94.7639 29.1978 93.2328C31.9271 91.7018 34.6563 90.1707 37.3856 88.6397C40.1148 87.1752 42.9107 85.6441 45.6399 84.2462C42.9772 85.9104 40.3145 87.508 37.5853 89.1056C34.9226 90.7032 32.1933 92.2343 29.4641 93.7653C26.7348 95.2964 24.0055 96.8274 21.2763 98.2919C18.547 99.8895 15.8178 101.354 13.0219 102.752Z",
    fill: "#C3DBE6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2607 47.435L27.8007 43.6406L28.0669 48.1672L32.4604 51.9615L32.2607 47.435Z",
    fill: "#A2C5D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 52.4278L23.5403 48.7L28.0669 48.1675L32.4603 51.9618L28.0003 52.4278Z",
    fill: "#A2C5D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.664 49.5644C30.2631 48.8987 35.3222 52.2271 42.0455 57.8853C48.7022 63.5436 56.6903 72.4636 56.6903 72.4636C56.6903 72.4636 46.5721 66.0731 39.9153 60.3483C33.192 54.6901 29.0649 50.2301 29.664 49.5644Z",
    fill: "#A2C5D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0663 48.1667C30.5292 50.0972 32.9922 52.0942 35.3887 54.0247C37.7851 56.0217 40.1815 58.0187 42.5779 60.0157C44.9743 62.0793 47.3042 64.0763 49.7006 66.1399C52.0305 68.2035 54.4269 70.2671 56.6902 72.3973C54.2272 70.4668 51.7642 68.4698 49.3678 66.5393C46.9714 64.5423 44.5749 62.5453 42.1785 60.5483C39.7821 58.4847 37.4522 56.4877 35.0558 54.4241C32.6594 52.3605 30.3295 50.2969 28.0663 48.1667Z",
    fill: "#C3DBE6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.695 177.374V50.1642C98.695 43.3077 104.287 37.7161 111.143 37.7161H332.679C339.536 37.7161 345.127 43.3077 345.127 50.1642V177.374C345.127 184.231 339.536 189.822 332.679 189.822H111.143C104.287 189.822 98.695 184.231 98.695 177.374Z",
    fill: "#C3DBE6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.809 187.159C106.017 187.159 101.358 182.499 101.358 176.708V50.3633C101.358 44.8382 105.818 40.3782 111.343 40.3782H332.413C337.938 40.3782 342.398 44.8382 342.398 50.3633V176.708C342.398 182.499 337.738 187.159 331.947 187.159H111.809Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.81 40.3782H332.413C337.938 40.3782 342.398 44.8382 342.398 50.3633V58.4179H100.825V50.3633C100.825 44.8382 105.352 40.3782 110.81 40.3782Z",
    fill: "#3A6D19"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.472 51.7615C115.758 51.7615 116.801 50.7184 116.801 49.4317C116.801 48.1449 115.758 47.1018 114.472 47.1018C113.185 47.1018 112.142 48.1449 112.142 49.4317C112.142 50.7184 113.185 51.7615 114.472 51.7615Z",
    fill: "#DCECF0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.185 51.7615C129.471 51.7615 130.514 50.7184 130.514 49.4317C130.514 48.1449 129.471 47.1018 128.185 47.1018C126.898 47.1018 125.855 48.1449 125.855 49.4317C125.855 50.7184 126.898 51.7615 128.185 51.7615Z",
    fill: "#DCECF0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.161 49.4317C144.161 50.6964 143.162 51.7615 141.831 51.7615C140.566 51.7615 139.501 50.763 139.501 49.4317C139.501 48.1669 140.5 47.1018 141.831 47.1018C143.162 47.1018 144.161 48.1003 144.161 49.4317Z",
    fill: "#DCECF0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.806 162.996H251.268",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.806 170.918H221.179",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.806 178.839H180.706",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.638 162.996H283.353",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M270.638 170.918H283.353",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M270.638 178.839H283.353",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M293.937 162.996H306.651",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M293.937 170.918H306.651",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.937 178.839H306.651",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M317.303 162.996H330.017",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M317.302 170.918H330.017",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M317.303 178.839H330.017",
    stroke: "#C3DBE6",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M329.085 62.8782V93.366",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M329.085 72.3306V86.2431",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M322.295 68.0032V98.5576",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M322.295 82.2498V91.3695",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M315.505 70.7329V101.221",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M315.505 86.2429V100.555",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308.715 69.2017V99.6895",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M308.715 73.6624V92.5675",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M301.926 79.6533V102.552",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M301.926 85.5773V95.6289",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M295.135 82.9155V110.142",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M295.135 90.1035V106.279",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M288.412 78.1216V101.82",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M288.412 83.6473V97.0939",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M281.622 68.6021V97.0263",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M281.622 74.1274V91.9675",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M274.832 82.0496V104.549",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M274.832 87.4414V98.3585",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M268.042 91.2356V113.935",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M268.042 98.425V106.746",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M261.252 85.3785V108.544",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M261.252 92.5668V101.287",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M254.463 91.2356V119.327",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M254.463 98.425V114.601",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M247.739 91.2356V110.673",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M247.739 98.425V106.347",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M240.949 88.2394V108.542",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M240.949 95.3633V101.288",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M234.16 91.2356V130.111",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M234.16 98.425V125.917",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M227.37 102.153V132.707",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M227.37 109.342V125.518",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M220.579 103.484V138.232",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M220.579 110.008V131.043",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M213.79 123.388V151.612",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M213.79 128.247V144.423",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M207.067 96.2942V126.782",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M207.067 103.418V123.388",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M200.277 98.7581V129.312",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M200.277 110.274V122.123",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M193.487 110.274V140.762",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M193.487 123.322V133.64",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M186.697 117.464V147.951",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M186.697 132.707V140.761",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M179.907 113.203V143.757",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M179.907 126.716V136.568",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M173.117 110.274V140.762",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M173.117 121.323V133.638",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M166.394 117.797V148.285",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M166.394 122.122V141.16",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M159.604 105.082V135.637",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M159.604 112.272V130.711",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M152.814 92.5668V123.055",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M152.814 99.6906V118.396",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M146.024 97.6927V128.247",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M146.024 102.885V121.058",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M139.235 91.3682V121.923",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.235 98.5586V103.551",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M132.444 84.4453V115",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M132.444 91.6356V99.6903",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M125.721 99.1575V135.37",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M125.721 102.952V128.247",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M118.932 119.926V150.414",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M118.932 112.137V125.917",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M112.142 117.797V148.285",
    stroke: "#C3DBE6",
    strokeWidth: 0.7903,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M112.142 123.322V141.162",
    stroke: "#C3DBE6",
    strokeWidth: 6.3222,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M402.041 134.772L393.055 148.618H376.546C377.079 139.631 384.534 132.508 393.587 132.508C396.65 132.508 399.578 133.374 402.041 134.772Z",
    fill: "#DCECF0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M410.696 149.616C410.696 152.878 409.764 155.874 408.233 158.47L394.986 149.35L403.773 135.837C407.966 138.965 410.696 143.958 410.696 149.616Z",
    fill: "#C3DBE6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M407.101 160.134C403.972 164.128 399.113 166.724 393.587 166.724C384.468 166.724 377.012 159.601 376.546 150.615H393.321L407.101 160.134Z",
    fill: "#A2C5D2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M404.238 274.564C404.238 274.564 416.553 271.102 415.754 263.248C414.955 255.459 405.503 253.862 410.961 246.939C416.42 240.016 417.951 236.421 414.09 232.76C410.296 229.099 417.219 226.569 416.952 219.846C416.686 213.056 409.896 211.724 405.702 214.72C401.442 217.716 404.438 222.974 402.773 227.102C401.109 231.229 394.985 232.627 393.92 237.752C392.855 242.878 398.38 247.138 398.447 250.866C398.513 254.594 391.39 258.721 391.39 264.246C391.457 269.838 401.908 274.497 404.238 274.564Z",
    fill: "#3A6D19"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M405.37 276.827C404.637 272.167 404.238 267.441 404.038 262.648C403.905 257.922 403.972 253.129 404.371 248.403C404.771 243.676 405.503 238.95 406.568 234.29C407.7 229.631 409.297 225.171 411.294 220.844C409.164 225.104 407.433 229.564 406.168 234.224C404.97 238.883 404.038 243.543 403.572 248.336C403.04 253.129 402.84 257.922 402.907 262.714C402.973 267.507 403.24 272.3 403.839 277.093L405.37 276.827Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M402.108 285.68C402.108 285.68 393.987 280.088 396.183 274.164C398.38 268.239 400.377 269.571 400.178 261.383C400.044 253.195 402.973 248.469 411.893 247.604C420.813 246.738 424.408 243.476 428.935 242.079C433.461 240.681 436.59 241.479 437.788 244.408C438.986 247.337 437.788 251.93 431.997 252.729C426.205 253.528 423.143 255.259 422.611 261.25C422.012 267.241 419.282 268.772 413.957 269.771C408.698 270.769 415.022 284.016 402.108 285.68Z",
    fill: "#3A6D19"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M401.842 284.482C402.308 276.294 404.837 268.306 409.431 261.516C413.957 254.793 420.547 249.467 428.136 246.605C420.68 249.667 414.29 255.126 410.03 261.849C405.703 268.572 403.439 276.56 403.24 284.482H401.842Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M398.647 277.093C398.647 277.093 389.194 275.828 387.597 270.303C385.999 264.778 389.793 262.781 384.468 260.717C379.143 258.72 375.215 259.386 374.15 254.061C373.085 248.735 371.421 245.074 367.227 242.811C363.033 240.547 366.561 234.556 371.021 236.42C375.548 238.284 376.946 241.812 383.336 241.28C390.526 240.68 394.653 242.478 393.987 248.069C393.455 252.463 394.52 252.995 399.179 254.926C407.167 258.254 405.636 266.442 403.107 271.967C400.577 277.492 398.647 277.093 398.647 277.093Z",
    fill: "#3A6D19"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M396.849 275.562C397.116 271.834 396.317 267.973 394.919 264.512C393.454 260.984 391.391 257.722 388.928 254.726C386.465 251.731 383.669 249.068 380.673 246.672C377.611 244.275 374.35 242.212 370.888 240.481C374.416 242.145 377.744 244.142 380.873 246.472C384.002 248.802 386.864 251.398 389.46 254.327C391.99 257.256 394.187 260.518 395.784 264.112C397.382 267.707 398.314 271.634 398.114 275.629L396.849 275.562Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M411.827 273.897H401.576H391.324C391.324 273.897 389.66 282.817 394.386 291.271H401.642H408.898C413.491 282.817 411.827 273.897 411.827 273.897Z",
    fill: "#304A5F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M413.225 277.558C413.158 275.295 412.959 273.897 412.959 273.897H401.576H390.193C390.193 273.897 389.993 275.295 389.926 277.558H413.225Z",
    fill: "#2C4C6A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7822 278.225C39.8487 274.963 46.1061 265.777 45.1741 262.116C43.2437 254.793 36.2541 256.923 36.9198 248.736C37.3192 244.009 34.3236 239.616 25.3371 240.215C16.2173 240.881 14.2203 237.352 9.62717 236.221C4.96746 235.089 1.90536 236.154 0.90685 239.216C-0.0916594 242.278 1.43939 246.738 7.29731 247.138C13.1552 247.537 15.352 248.602 16.3505 254.593C17.349 260.584 22.4081 257.056 26.8681 260.252C30.4627 262.848 24.8711 265.244 28.4657 269.904C30.5293 272.7 38.0514 273.365 39.7822 278.225Z",
    fill: "#497D2D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5837 277.16C37.7849 269.172 34.9225 261.384 30.1297 254.86C25.3369 248.403 18.547 243.344 10.7586 240.814C18.547 243.144 25.6031 248.004 30.6622 254.461C35.7213 260.918 38.9166 268.839 39.9151 277.027L38.5837 277.16Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8369 276.827C47.8369 276.827 34.59 274.897 34.3903 266.709C34.1906 258.521 41.6461 255.792 35.0559 249.401C28.4658 242.944 28.5323 239.216 31.9938 234.956C35.4553 230.629 27.8667 229.032 27.2676 221.976C26.6684 214.919 33.4583 212.59 38.2512 215.119C43.044 217.649 40.6476 223.507 42.9774 227.567C45.3073 231.628 51.8309 232.227 53.5616 237.419C55.359 242.611 53.2954 247.005 53.7613 250.866C54.2273 254.727 59.0202 258.854 59.7524 264.579C60.4181 270.237 50.2333 276.494 47.8369 276.827Z",
    fill: "#497D2D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1047 279.357C47.2378 274.431 46.9716 269.438 46.5056 264.512C46.0396 259.586 45.2408 254.66 44.2423 249.801C43.1772 244.942 41.7793 240.149 39.982 235.489C38.1847 230.829 35.9214 226.369 33.1921 222.176C35.988 226.303 38.3844 230.696 40.2483 235.356C42.1122 240.016 43.6432 244.742 44.8414 249.601C45.9731 254.461 46.905 259.387 47.4375 264.379C48.0367 269.372 48.3695 274.364 48.3695 279.423L47.1047 279.357Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6116 270.103C65.943 264.045 61.1501 265.709 66.7418 263.18C72.3334 260.65 73.9311 260.517 74.7299 254.726C75.5287 248.934 77.0597 244.874 81.4532 242.211C85.78 239.548 81.6529 233.291 76.9266 235.621C72.2003 237.951 70.9355 241.811 64.0791 241.678C56.3573 241.479 52.0304 243.675 53.0955 249.666C53.9609 254.326 52.4298 258.254 47.5038 260.65C39.1829 264.711 47.9033 272.299 50.4328 280.554C54.8928 269.171 63.2803 276.094 64.6116 270.103Z",
    fill: "#497D2D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5654 279.422C50.0995 275.161 50.8317 270.835 52.2962 266.907C53.7607 262.98 55.8908 259.318 58.487 255.99C61.0165 252.662 63.9455 249.666 67.1407 247.004C70.3359 244.341 73.7974 241.944 77.3921 239.947C73.7974 242.078 70.4025 244.474 67.3404 247.27C64.2117 249.999 61.4159 253.061 59.0195 256.456C56.6231 259.784 54.5595 263.446 53.2947 267.307C51.9634 271.167 51.3643 275.295 51.9634 279.289L50.5654 279.422Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1213 273.898H46.3726H56.624C56.624 273.898 58.2882 282.818 53.5619 291.272H46.306H39.0502C34.4571 282.818 36.1213 273.898 36.1213 273.898Z",
    fill: "#304A5F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.723 277.559C34.7896 275.296 34.9893 273.898 34.9893 273.898H46.3723H57.7553C57.7553 273.898 57.955 275.296 58.0216 277.559H34.723Z",
    fill: "#2C4C6A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M362.701 140.296H324.092C322.827 140.296 321.828 139.297 321.828 138.033V111.539C321.828 110.274 322.827 109.276 324.092 109.276H362.701C363.965 109.276 364.964 110.274 364.964 111.539V138.033C364.964 139.297 363.965 140.296 362.701 140.296Z",
    fill: "white",
    stroke: "#C3DBE6",
    strokeWidth: 2.7309,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M324.957 136.434C328.019 136.434 328.019 132.24 331.081 132.24C334.143 132.24 334.143 124.851 337.206 124.851C340.268 124.851 339.402 129.711 342.531 129.711C345.593 129.711 346.458 117.063 349.521 117.063C352.583 117.063 352.583 122.588 355.645 122.588C358.707 122.588 358.707 117.063 361.769 117.063",
    stroke: "#C3DBE6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M383.536 81.3845H380.94C380.474 81.3845 380.075 81.1182 379.875 80.6522C379.675 80.1197 379.476 79.6537 379.276 79.1877C379.076 78.7883 379.143 78.2558 379.476 77.923L381.339 76.0591C381.739 75.6597 381.739 74.9274 381.339 74.528L379.476 72.6641C379.076 72.2647 378.344 72.2647 377.945 72.6641L376.081 74.528C375.748 74.8609 375.215 74.9274 374.816 74.7277C374.35 74.4615 373.817 74.2618 373.351 74.1286C372.885 73.9955 372.619 73.5961 372.619 73.0635V70.4674C372.619 69.8683 372.153 69.4023 371.554 69.4023H368.958C368.359 69.4023 367.893 69.8683 367.893 70.4674V73.0635C367.893 73.5295 367.627 73.9289 367.161 74.1286C366.628 74.3283 366.162 74.528 365.696 74.7277C365.297 74.9274 364.764 74.8609 364.431 74.528L362.567 72.6641C362.168 72.2647 361.436 72.2647 361.036 72.6641L359.173 74.528C358.773 74.9274 358.773 75.6597 359.173 76.0591L361.036 77.923C361.369 78.2558 361.436 78.7883 361.236 79.1877C360.97 79.6537 360.77 80.1862 360.637 80.6522C360.504 81.1182 360.104 81.3845 359.572 81.3845H356.976C356.377 81.3845 355.911 81.8504 355.911 82.4495V85.0457C355.911 85.6448 356.377 86.1107 356.976 86.1107H359.572C360.038 86.1107 360.437 86.377 360.637 86.843C360.837 87.3755 361.036 87.8415 361.236 88.3075C361.436 88.7069 361.369 89.2394 361.036 89.5722L359.173 91.4361C358.773 91.8355 358.773 92.5678 359.173 92.9672L361.036 94.8311C361.436 95.2305 362.168 95.2305 362.567 94.8311L364.431 92.9672C364.764 92.6343 365.297 92.5678 365.696 92.7675C366.162 93.0337 366.695 93.2334 367.161 93.3666C367.627 93.4997 367.893 93.8991 367.893 94.4316V97.0278C367.893 97.6269 368.359 98.0928 368.958 98.0928H371.554C372.153 98.0928 372.619 97.6269 372.619 97.0278V94.4316C372.619 93.9657 372.885 93.5663 373.351 93.3666C373.884 93.1669 374.35 92.9672 374.816 92.7675C375.215 92.5678 375.748 92.6343 376.081 92.9672L377.945 94.8311C378.344 95.2305 379.076 95.2305 379.476 94.8311L381.339 92.9672C381.739 92.5678 381.739 91.8355 381.339 91.4361L379.476 89.5722C379.143 89.2394 379.076 88.7069 379.276 88.3075C379.542 87.8415 379.742 87.3089 379.875 86.843C380.008 86.377 380.408 86.1107 380.94 86.1107H383.536C384.135 86.1107 384.601 85.6448 384.601 85.0457V82.4495C384.601 81.917 384.135 81.3845 383.536 81.3845ZM370.156 89.306C367.161 89.306 364.698 86.843 364.698 83.8474C364.698 80.8519 367.161 78.3889 370.156 78.3889C373.152 78.3889 375.615 80.8519 375.615 83.8474C375.615 86.843 373.218 89.306 370.156 89.306Z",
    fill: "#C3DBE6"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M402.175 93.2999H400.511C400.245 93.2999 399.979 93.1002 399.845 92.8339C399.712 92.5011 399.579 92.1683 399.446 91.902C399.313 91.6357 399.38 91.3029 399.579 91.1032L400.711 89.9715C400.977 89.7053 400.977 89.2393 400.711 88.973L399.513 87.7748C399.246 87.5085 398.78 87.5085 398.514 87.7748L397.382 88.9065C397.183 89.1062 396.85 89.1727 396.584 89.0396C396.251 88.9065 395.985 88.7733 395.652 88.6402C395.385 88.5736 395.186 88.3073 395.186 87.9745V86.3103C395.186 85.9109 394.853 85.6447 394.52 85.6447H392.856C392.456 85.6447 392.19 85.9775 392.19 86.3103V87.9745C392.19 88.2408 391.991 88.507 391.724 88.6402C391.391 88.7733 391.059 88.9065 390.792 89.0396C390.526 89.1727 390.193 89.1062 389.994 88.9065L388.862 87.7748C388.596 87.5085 388.13 87.5085 387.863 87.7748L386.665 88.973C386.399 89.2393 386.399 89.7053 386.665 89.9715L387.797 91.1032C387.996 91.3029 388.063 91.6357 387.93 91.902C387.797 92.2348 387.664 92.5011 387.531 92.8339C387.464 93.1002 387.198 93.2999 386.865 93.2999H385.201C384.801 93.2999 384.535 93.6327 384.535 93.9656V95.6298C384.535 96.0292 384.868 96.2954 385.201 96.2954H386.865C387.131 96.2954 387.397 96.4951 387.531 96.7614C387.664 97.0942 387.797 97.4271 387.93 97.6933C388.063 97.9596 387.996 98.2924 387.797 98.4921L386.665 99.6238C386.399 99.8901 386.399 100.356 386.665 100.622L387.863 101.821C388.13 102.087 388.596 102.087 388.862 101.821L389.994 100.689C390.193 100.489 390.526 100.423 390.792 100.556C391.125 100.689 391.391 100.822 391.724 100.955C391.991 101.022 392.19 101.288 392.19 101.621V103.285C392.19 103.684 392.523 103.951 392.856 103.951H394.52C394.919 103.951 395.186 103.618 395.186 103.285V101.621C395.186 101.355 395.385 101.088 395.652 100.955C395.985 100.822 396.317 100.689 396.584 100.556C396.85 100.423 397.183 100.489 397.382 100.689L398.514 101.821C398.78 102.087 399.246 102.087 399.513 101.821L400.711 100.622C400.977 100.356 400.977 99.8901 400.711 99.6238L399.579 98.4921C399.38 98.2924 399.313 97.9596 399.446 97.6933C399.579 97.3605 399.712 97.0942 399.845 96.7614C399.912 96.4951 400.178 96.2954 400.511 96.2954H402.175C402.575 96.2954 402.841 95.9626 402.841 95.6298V93.9656C402.841 93.5662 402.508 93.2999 402.175 93.2999ZM393.721 98.2259C391.791 98.2259 390.26 96.6948 390.26 94.7644C390.26 92.8339 391.791 91.3029 393.721 91.3029C395.652 91.3029 397.183 92.8339 397.183 94.7644C397.183 96.6948 395.652 98.2259 393.721 98.2259Z",
    fill: "#C3DBE6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M386.199 64.0108H385.2C385.001 64.0108 384.868 63.8777 384.801 63.7445C384.734 63.5448 384.668 63.3451 384.535 63.1454C384.468 63.0123 384.468 62.8126 384.601 62.6794L385.334 61.9472C385.533 61.7475 385.533 61.4812 385.334 61.3481L384.601 60.6159C384.402 60.4162 384.135 60.4162 384.002 60.6159L383.27 61.3481C383.137 61.4812 382.937 61.4812 382.804 61.4147C382.604 61.3481 382.405 61.215 382.205 61.1484C382.005 61.0818 381.939 60.9487 381.939 60.749V59.7505C381.939 59.4842 381.739 59.3511 381.539 59.3511H380.541C380.274 59.3511 380.141 59.5508 380.141 59.7505V60.749C380.141 60.9487 380.008 61.0818 379.875 61.1484C379.675 61.215 379.476 61.2815 379.276 61.4147C379.143 61.4812 378.943 61.4812 378.81 61.3481L378.078 60.6159C377.878 60.4162 377.612 60.4162 377.479 60.6159L376.746 61.3481C376.547 61.5478 376.547 61.8141 376.746 61.9472L377.479 62.6794C377.612 62.8126 377.612 63.0123 377.545 63.1454C377.479 63.3451 377.345 63.5448 377.279 63.7445C377.212 63.9442 377.079 64.0108 376.879 64.0108H375.881C375.615 64.0108 375.482 64.2105 375.482 64.4102V65.4087C375.482 65.675 375.681 65.8081 375.881 65.8081H376.879C377.079 65.8081 377.212 65.9412 377.279 66.0744C377.345 66.2741 377.412 66.4738 377.545 66.6735C377.612 66.8066 377.612 67.0063 377.479 67.1395L376.746 67.8717C376.547 68.0714 376.547 68.3377 376.746 68.4708L377.479 69.203C377.678 69.4027 377.945 69.4027 378.078 69.203L378.81 68.4708C378.943 68.3377 379.143 68.3377 379.276 68.4042C379.476 68.4708 379.675 68.6039 379.875 68.6705C380.075 68.7371 380.141 68.8702 380.141 69.0699V70.0684C380.141 70.3347 380.341 70.4678 380.541 70.4678H381.539C381.805 70.4678 381.939 70.2681 381.939 70.0684V69.0699C381.939 68.8702 382.072 68.7371 382.205 68.6705C382.405 68.6039 382.604 68.5374 382.804 68.4042C382.937 68.3377 383.137 68.3377 383.27 68.4708L384.002 69.203C384.202 69.4027 384.468 69.4027 384.601 69.203L385.334 68.4708C385.533 68.2711 385.533 68.0048 385.334 67.8717L384.601 67.1395C384.468 67.0063 384.468 66.8066 384.535 66.6735C384.601 66.4738 384.734 66.2741 384.801 66.0744C384.868 65.8747 385.001 65.8081 385.2 65.8081H386.199C386.465 65.8081 386.598 65.6084 386.598 65.4087V64.4102C386.665 64.2105 386.465 64.0108 386.199 64.0108ZM381.007 67.0729C379.808 67.0729 378.876 66.1409 378.876 64.9427C378.876 63.7445 379.808 62.8126 381.007 62.8126C382.205 62.8126 383.137 63.7445 383.137 64.9427C383.137 66.1409 382.205 67.0729 381.007 67.0729Z",
    fill: "#C3DBE6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M235.357 241.811C235.091 239.548 233.893 237.417 232.362 235.687C230.831 233.956 228.967 232.558 227.103 231.16C224.706 229.429 222.11 227.765 219.181 227.432C217.783 227.299 216.319 227.432 215.121 228.165C213.922 228.897 212.991 230.162 212.991 231.56C212.991 233.29 214.189 234.755 215.52 235.82C216.851 236.885 218.382 237.75 219.448 239.082C220.779 240.812 221.178 243.142 222.243 245.073C223.308 246.937 225.039 248.335 227.103 248.934C228.9 249.466 232.029 249.732 233.427 248.135C234.958 246.471 235.623 244.074 235.357 241.811Z",
    fill: "#097A57"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M235.823 242.011C235.158 240.413 234.891 238.616 235.291 236.885C235.757 234.955 237.088 233.291 237.754 231.36C238.419 229.43 238.486 227.233 239.618 225.502C240.882 223.505 243.545 222.507 245.808 223.239C248.072 223.971 249.603 226.434 249.336 228.764C249.137 230.428 248.138 231.826 247.739 233.424C247.14 235.687 247.606 238.15 246.94 240.413C246.341 242.277 244.943 243.875 243.146 244.674C242.28 245.073 241.415 245.273 240.483 245.606C239.884 245.805 239.218 246.205 238.619 246.072C237.221 245.672 236.289 243.143 235.823 242.011Z",
    fill: "#097A57"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M240.217 256.456C241.082 254.858 242.879 253.727 244.743 253.66C246.074 253.593 247.339 253.993 248.671 254.126C250.135 254.259 251.6 253.993 253.064 254.326C254.462 254.659 255.926 255.79 255.793 257.255C255.727 258.32 254.795 259.185 253.796 259.518C252.798 259.851 251.733 259.851 250.668 259.784C249.603 259.718 248.537 259.651 247.472 259.917C246.274 260.25 245.209 261.049 244.077 261.648C242.879 262.247 240.949 262.78 240.15 261.448C239.218 259.984 239.418 257.854 240.217 256.456Z",
    fill: "#097A57"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M236.356 274.762C236.356 274.762 237.754 257.255 246.94 256.256",
    stroke: "#2C4C6A",
    strokeWidth: 0.724,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M236.489 278.756C236.489 278.756 235.024 251.463 242.28 231.826",
    stroke: "#2C4C6A",
    strokeWidth: 0.724,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M236.689 262.58C236.689 262.58 236.955 243.808 221.045 233.357",
    stroke: "#2C4C6A",
    strokeWidth: 0.724,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M246.54 274.097H236.356H226.171C226.171 274.097 224.507 282.951 229.166 291.271H236.356H243.545C248.204 282.951 246.54 274.097 246.54 274.097Z",
    fill: "#304A5F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M247.938 277.692C247.872 275.429 247.672 274.097 247.672 274.097H236.422H225.172C225.172 274.097 224.972 275.495 224.906 277.692H247.938Z",
    fill: "#2C4C6A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M288.079 12.2207H275.564V31.4587H288.079V12.2207Z",
    fill: "#C3DBE6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M281.821 0.105957L270.438 14.2182H293.204L281.821 0.105957Z",
    fill: "#C3DBE6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M188.96 65.0762H176.445V84.3141H188.96V65.0762Z",
    fill: "#C3DBE6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M182.702 96.4292L194.085 82.3169H171.319L182.702 96.4292Z",
    fill: "#C3DBE6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M375.23 30.3272C376.291 23.795 371.855 17.6402 365.322 16.5801C358.79 15.52 352.635 19.956 351.575 26.4881C350.515 33.0203 354.951 39.1751 361.483 40.2352C368.015 41.2953 374.17 36.8594 375.23 30.3272Z",
    stroke: "#A2C5D2",
    strokeWidth: 8.5831,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M357.441 38.7829C353.847 36.7194 351.45 32.8584 351.45 28.3984",
    stroke: "#C3DBE6",
    strokeWidth: 8.5831,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M351.45 28.3969C351.45 21.8067 356.776 16.4148 363.432 16.4148",
    stroke: "#DCECF0",
    strokeWidth: 8.5831,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M104.419 29.9948H96.631C95.7657 29.9948 95.1 29.3291 95.1 28.4637V20.6753C95.1 19.81 95.7657 19.1443 96.631 19.1443H104.419C105.285 19.1443 105.95 19.81 105.95 20.6753V28.4637C105.95 29.2625 105.285 29.9948 104.419 29.9948Z",
    fill: "#C3DBE6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9624 25.135L99.1606 26.4664L103.088 22.6055",
    stroke: "white",
    strokeWidth: 2.2181,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M390.459 192.686H382.671C381.805 192.686 381.14 192.02 381.14 191.155V183.367C381.14 182.501 381.805 181.836 382.671 181.836H390.459C391.325 181.836 391.99 182.501 391.99 183.367V191.155C391.99 191.954 391.325 192.686 390.459 192.686Z",
    fill: "#C3DBE6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M384.002 187.827L385.267 189.159L389.194 185.298",
    stroke: "white",
    strokeWidth: 2.2181,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1578 134.306H44.5751C43.3103 134.306 42.3118 133.307 42.3118 132.042V120.46C42.3118 119.195 43.3103 118.196 44.5751 118.196H56.1578C57.4226 118.196 58.4211 119.195 58.4211 120.46V132.042C58.4876 133.307 57.4226 134.306 56.1578 134.306Z",
    fill: "#C3DBE6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5718 127.117L48.3692 129.114L54.2271 123.389",
    stroke: "white",
    strokeWidth: 3.3059,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M164.263 28.9302H159.936V33.5233H164.263V28.9302Z",
    fill: "#C3DBE6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M170.453 26.1338H166.127V33.4562H170.453V26.1338Z",
    fill: "#C3DBE6"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M176.578 22.6721H172.251V33.5226H176.578V22.6721Z",
    fill: "#C3DBE6"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M182.702 18.2122H178.375V33.4561H182.702V18.2122Z",
    fill: "#C3DBE6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M116.534 285.081H109.877L109.212 274.297L115.669 273.897L116.534 285.081Z",
    fill: "#FFC29F"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0537 284.881L74.5301 284.682L75.6617 275.229L81.7194 276.094L81.0537 284.881Z",
    fill: "#FFC29F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M86.845 172.649L73.7978 280.821H81.7859L100.758 202.138L108.812 280.821H116.734L114.803 172.649H86.845Z",
    fill: "#097A57"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M134.44 132.842C134.44 132.842 135.772 130.313 135.639 129.115C135.505 127.916 135.306 126.252 136.504 124.455C136.77 124.056 137.569 122.924 137.569 122.924C137.569 122.924 138.235 123.59 137.902 124.322C137.569 125.054 137.369 125.786 137.369 125.786C137.369 125.786 137.968 124.721 140.165 124.122C141.164 123.856 145.224 122.791 145.224 122.791C145.823 122.791 145.69 123.59 144.625 124.122C144.625 124.122 145.158 124.655 144.226 125.187C144.226 125.187 144.891 125.653 143.627 126.385C143.627 126.385 144.159 126.785 142.828 127.584C141.63 128.316 139.766 129.314 139.3 129.98C138.767 130.845 137.835 133.974 137.835 133.974L134.44 132.842Z",
    fill: "#FFC29F"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5034 121.259C92.5034 121.259 84.3822 123.655 82.5183 124.121C80.6544 124.587 82.5183 136.369 85.0478 149.882C87.5774 163.396 86.8451 172.715 86.8451 172.715H114.737C114.737 172.715 115.868 129.113 115.269 127.649C114.071 124.986 102.422 121.259 102.422 121.259H92.5034Z",
    fill: "#3A6D19"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1679 111.607C94.1679 111.607 94.4341 118.264 93.3025 120.993L94.7004 123.722L98.4282 125.985L100.825 124.188L101.49 122.125V111.607H94.1679Z",
    fill: "#FFA980"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1719 106.68C90.8391 105.815 90.8391 104.817 91.2385 104.018C91.5713 103.352 92.1039 102.753 92.4367 102.087C92.703 101.488 92.9027 100.823 93.3686 100.357C93.8346 99.8906 94.5669 99.7575 95.2325 99.8906C95.8982 100.024 96.4307 100.423 96.8967 100.889C97.5624 101.555 97.9618 102.354 98.1615 103.286C98.4278 104.351 98.2946 105.482 98.0949 106.547C97.8952 107.546 97.629 108.544 96.9633 109.277C96.4307 109.876 95.6985 110.209 94.8997 110.275C94.1009 110.342 92.9692 110.142 92.5698 109.41C92.3701 109.077 92.237 108.611 92.0373 108.278C91.771 107.679 91.3716 107.213 91.1719 106.68Z",
    fill: "#2B2F3A"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M105.484 100.956C105.484 100.956 107.082 115.801 102.755 117.931C99.9588 119.329 95.4988 117.865 94.7666 111.208C94.1009 104.618 97.0298 101.422 100.558 100.956C103.62 100.557 105.484 100.956 105.484 100.956Z",
    fill: "#FFC29F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6998 108.345C94.6998 108.345 93.7013 107.214 92.7028 108.345C91.7043 109.477 93.5016 111.74 94.8329 111.874L94.6998 108.345Z",
    fill: "#FFC29F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9632 103.087C97.762 103.22 98.5608 103.087 99.3596 103.22C100.292 103.353 101.157 103.752 102.089 104.085C103.42 104.551 104.818 104.884 106.216 104.751C107.614 104.618 109.012 103.952 109.811 102.82C110.676 101.622 110.809 100.025 110.21 98.7598C109.611 97.4284 108.28 96.4965 106.815 96.4299C105.218 96.2968 103.686 97.0956 102.222 97.6281C100.624 98.2272 98.8936 98.5601 97.1629 98.5601C96.4306 98.5601 95.765 98.5601 95.0327 98.6932C94.3671 98.8929 93.7014 99.2923 93.4351 99.958C93.1023 100.823 93.6348 101.422 94.3005 101.955C95.1659 102.421 95.9647 102.953 96.9632 103.087Z",
    fill: "#2B2F3A"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M93.568 120.194C93.568 120.194 94.5 123.456 98.494 125.986C98.3609 127.184 94.9659 129.647 93.5015 125.586C92.7692 123.589 92.5695 121.259 92.5695 121.259L93.568 120.194Z",
    fill: "#173900"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4275 125.986C101.423 123.922 101.49 120.328 101.49 120.328L102.422 121.26C102.422 121.26 103.087 125.32 101.689 127.184C100.691 128.449 98.5606 126.785 98.4275 125.986Z",
    fill: "#173900"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9813 173.115C84.9813 173.115 87.7771 177.376 89.0419 178.374C90.2401 179.373 91.172 181.37 91.172 181.37L87.5774 186.229C87.5774 186.229 85.4472 185.497 84.715 182.967C84.0493 180.371 83.3836 180.105 82.252 177.642C81.1204 175.179 81.1204 175.179 81.1204 175.179L84.9813 173.115Z",
    fill: "#FFC29F"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1187 124.588C82.1187 124.588 77.9915 124.854 76.0611 132.442C74.1306 140.031 71.7342 152.479 71.0685 157.805C70.8023 160.068 82.7178 179.772 82.7178 179.772C82.7178 179.772 85.1143 177.642 87.1778 175.844C87.1778 175.844 80.5877 162.065 80.5877 157.006C80.5877 157.006 86.5122 140.564 86.7119 135.571C86.9116 130.379 86.9781 125.053 82.1187 124.588Z",
    fill: "#55962C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M115.336 127.65C116.867 127.916 121.593 138.434 124.655 143.893C127.651 149.351 127.651 149.351 127.651 149.351L134.906 130.712C134.906 130.712 137.303 130.313 138.767 132.443C138.767 132.443 134.906 157.605 133.908 160.401C132.909 163.197 129.914 165.261 124.588 158.537C119.263 151.814 110.01 138.833 109.278 137.369C108.479 135.905 106.349 126.252 115.336 127.65Z",
    fill: "#55962C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M109.877 284.349H116.068C116.068 284.349 116.734 284.349 118.797 286.479C120.861 288.609 126.785 286.545 128.982 290.872H109.345C109.345 290.806 107.547 287.411 109.877 284.349Z",
    fill: "#005B84"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2668 290.806C71.5345 288.343 73.2653 286.48 73.7978 284.283C74.1306 282.952 80.9871 282.086 81.6528 285.082C82.3184 287.944 81.7859 290.806 81.7859 290.806H72.2668Z",
    fill: "#005B84"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6902 178.866L86.1712 186.946L87.4356 187.81L92.9545 179.729L91.6902 178.866Z",
    fill: "#22AD82"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M114.803 172.649H86.845V174.646H114.803V172.649Z",
    fill: "#22AD82"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M100.758 202.138L104.685 187.627L102.089 215.052L100.758 202.138Z",
    fill: "#22AD82"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M352.583 289.941L339.669 233.359H344.528L354.513 289.941C354.38 291.139 352.583 291.139 352.583 289.941Z",
    fill: "#2C4C6A"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M319.898 289.941L306.984 233.359H311.843L321.828 289.941C321.762 291.139 319.964 291.139 319.898 289.941Z",
    fill: "#2C4C6A"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M275.165 289.941L288.079 233.359H283.219L273.234 289.941C273.301 291.139 275.098 291.139 275.165 289.941Z",
    fill: "#A2C5D2"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M357.442 188.558H331.148C329.484 188.558 327.953 189.624 327.353 191.221L314.506 226.568C313.574 229.165 315.504 231.96 318.3 231.96H344.594C346.259 231.96 347.79 230.895 348.389 229.298L361.236 193.95C362.235 191.354 360.238 188.558 357.442 188.558Z",
    fill: "#A2C5D2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M347.124 234.755H279.625C278.826 234.755 278.227 234.156 278.227 233.357C278.227 232.559 278.826 231.959 279.625 231.959H347.19C347.989 231.959 348.588 232.559 348.588 233.357C348.588 234.09 347.923 234.755 347.124 234.755Z",
    fill: "#A2C5D2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M347.124 234.755H319.898C319.099 234.755 318.5 234.156 318.5 233.357C318.5 232.559 319.099 231.959 319.898 231.959H347.124C347.923 231.959 348.522 232.559 348.522 233.357C348.588 234.09 347.923 234.755 347.124 234.755Z",
    fill: "#91B9C4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M305.652 289.941L318.566 233.359H313.774L303.788 289.941C303.855 291.139 305.586 291.139 305.652 289.941Z",
    fill: "#A2C5D2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M327.22 152.08C327.22 152.08 323.359 152.279 323.026 156.473C322.693 160.667 323.492 162.864 321.628 167.057C319.831 171.251 318.366 176.909 325.888 177.442C333.477 177.974 335.807 177.641 338.137 179.439C340.467 181.236 348.388 175.778 345.592 170.918C342.73 166.059 341.665 163.263 342.796 159.535C343.995 155.807 341.532 151.68 336.939 149.883C333.211 148.418 330.082 148.685 327.22 152.08Z",
    fill: "#21323F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M325.223 176.178C325.223 176.178 326.288 179.506 323.692 189.025C321.096 198.544 320.231 201.673 317.768 203.47C316.237 204.602 299.062 204.602 299.062 204.602V199.743L314.24 197.879C314.24 197.879 316.17 188.493 318.1 182.568C318.766 180.505 319.898 175.246 322.294 174.181C324.624 173.116 325.223 176.178 325.223 176.178Z",
    fill: "#22AD82"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M344.728 192.419C343.995 197.811 342.065 210.925 342.065 210.925H321.962C321.962 210.925 322.561 202.87 321.562 198.544C321.362 197.745 321.163 197.079 320.83 196.546C319.299 194.083 317.901 191.754 317.834 189.158C317.834 188.558 317.901 187.893 318.101 187.227C319.033 183.832 320.364 176.443 322.028 174.38C323.692 172.316 332.08 172.582 332.08 172.582C332.08 172.582 343.063 172.582 346.325 174.446C347.191 174.912 347.523 176.044 347.59 177.375C347.856 181.502 345.26 188.359 344.728 192.419Z",
    fill: "#097A57"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M341.466 194.216C341.466 194.216 326.089 195.481 321.562 198.543C321.362 197.744 321.163 197.078 320.83 196.546C319.299 194.083 317.901 191.753 317.834 189.157C318.833 191.287 321.429 194.083 328.019 194.149C338.67 194.349 341.466 194.216 341.466 194.216Z",
    fill: "#1A8B68"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M336.939 200.341C336.939 200.341 327.353 200.674 324.291 200.873C324.291 200.873 321.562 199.808 319.831 199.675C317.235 199.476 314.972 202.072 314.306 204.535H336.539L336.939 200.341Z",
    fill: "#FFC29F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M347.257 175.511C347.257 175.511 350.119 180.77 351.916 187.76C353.78 194.749 356.31 201.805 353.98 203.802C351.65 205.733 336.672 205.001 336.672 205.001L336.273 199.742L347.656 197.878C347.656 197.878 343.329 187.094 342.663 185.163C341.998 183.233 341.465 177.242 343.862 176.177C346.258 175.112 347.257 175.511 347.257 175.511Z",
    fill: "#22AD82"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M292.339 285.282H288.944L288.478 280.223L292.672 279.823L292.339 285.282Z",
    fill: "#FFC29F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M292.339 285.281C292.339 285.281 293.604 286.613 293.204 289.542C293.005 290.94 290.009 290.807 284.95 290.807H279.891C279.026 290.807 278.626 289.742 279.292 289.209C279.625 288.943 280.024 288.676 280.623 288.543C286.348 286.746 288.944 285.348 288.944 285.348H292.339V285.281Z",
    fill: "#192730"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M333.011 210.992C333.011 212.723 337.005 218.647 336.206 224.439C335.674 228.233 332.412 231.961 324.823 231.961C314.439 231.961 297.93 231.828 295.267 231.961C293.137 232.027 292.139 232.094 293.337 236.155C296.332 245.74 293.803 261.983 293.004 284.016H288.478C288.478 284.016 284.484 261.117 282.819 250.067C280.223 232.826 276.296 226.103 283.818 222.508C291.739 218.714 321.961 210.926 321.961 210.926H333.011V210.992Z",
    fill: "#55962C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M302.125 285.282H298.73L298.264 280.223L302.457 279.823L302.125 285.282Z",
    fill: "#FFC29F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M302.124 285.281C302.124 285.281 303.389 286.613 302.99 289.542C302.79 290.94 299.794 290.807 294.735 290.807H289.676C288.811 290.807 288.411 289.742 289.077 289.209C289.41 288.943 289.809 288.676 290.408 288.543C296.133 286.746 298.729 285.348 298.729 285.348H302.124V285.281Z",
    fill: "#21323F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M342.065 210.992C342.065 212.723 346.059 218.647 345.26 224.439C344.727 228.233 341.466 231.961 333.877 231.961C323.492 231.961 307.05 231.961 304.321 231.961C302.191 231.961 301.192 232.094 302.391 236.155C305.386 245.74 304.055 262.182 302.524 284.016H297.997C297.997 284.016 293.537 261.117 291.873 250.067C289.277 232.826 285.349 226.103 292.871 222.508C300.793 218.714 328.685 210.926 328.685 210.926H342.065V210.992Z",
    fill: "#3A6D19"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M326.622 172.848C326.622 172.848 326.555 177.108 329.484 179.571C329.484 179.571 335.675 176.709 337.871 172.848C337.871 172.848 332.08 172.182 326.622 172.848Z",
    fill: "#FFC29F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M327.886 172.715C327.886 172.715 329.417 172.582 329.417 170.785C329.417 168.987 329.617 165.592 329.617 165.592L335.342 166.058C335.342 166.058 334.876 171.65 335.808 172.715C336.74 173.714 336.74 173.714 336.74 173.714C336.74 173.714 328.818 175.045 327.886 172.715Z",
    fill: "#FFC29F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M329.418 170.053C329.418 170.053 333.212 170.652 335.209 169.055L335.342 166.126L329.418 167.39V170.053Z",
    fill: "#FFA980"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M326.089 154.21C326.089 154.21 321.03 168.056 328.153 169.587C335.209 171.118 336.673 163.729 336.673 163.729C336.673 163.729 338.537 163.263 338.803 161.732C339.07 160.201 336.939 160.8 336.939 160.8C336.939 160.8 338.803 155.075 334.543 153.211C330.016 151.214 326.954 152.213 326.089 154.21Z",
    fill: "#FFC29F"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M326.755 152.546C326.755 152.546 328.353 160.334 336.94 160.8C336.94 160.8 339.137 155.275 337.672 152.945C336.141 150.615 329.285 149.151 326.755 152.546Z",
    fill: "#21323F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M318.966 203.003H285.216L277.162 180.769C276.829 179.837 277.495 178.839 278.493 178.839H309.181C309.78 178.839 310.312 179.238 310.512 179.771L318.966 203.003Z",
    fill: "#21323F"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M339.003 205.066H305.453C304.854 205.066 304.388 204.6 304.388 204.001C304.388 203.402 304.854 202.936 305.453 202.936H339.003C339.602 202.936 340.068 203.402 340.068 204.001C340.068 204.6 339.602 205.066 339.003 205.066Z",
    fill: "#21323F"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M318.833 205.066H285.283C284.684 205.066 284.218 204.6 284.218 204.001C284.218 203.402 284.684 202.936 285.283 202.936H318.833C319.432 202.936 319.898 203.402 319.898 204.001C319.898 204.6 319.432 205.066 318.833 205.066Z",
    fill: "#21323F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M398.513 289.54L379.674 207.063H386.731L401.309 289.54C401.242 291.271 398.58 291.271 398.513 289.54Z",
    fill: "#2C4C6A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M208.331 289.54L189.492 207.063H196.549L211.127 289.54C211.06 291.271 208.464 291.271 208.331 289.54Z",
    fill: "#2C4C6A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M133.842 289.541L152.68 207.064H145.624L131.046 289.541C131.179 291.272 133.775 291.272 133.842 289.541Z",
    fill: "#C3DBE6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M314.772 289.54L333.61 207.063H326.554L311.976 289.54C312.109 291.271 314.705 291.271 314.772 289.54Z",
    fill: "#C3DBE6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M132.777 208.994H401.509C402.441 208.994 403.173 208.262 403.173 207.33V206.798C403.173 205.866 402.441 205.134 401.509 205.134H132.777C131.845 205.134 131.112 205.866 131.112 206.798V207.33C131.046 208.262 131.845 208.994 132.777 208.994Z",
    fill: "#A2C5D2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M341.398 208.994H401.176C402.241 208.994 403.106 208.129 403.106 207.064C403.106 205.999 402.241 205.134 401.176 205.134H341.398C340.333 205.134 339.468 205.999 339.468 207.064C339.468 208.129 340.333 208.994 341.398 208.994Z",
    fill: "#91B9C4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M189.891 203.003H223.641L231.696 180.769C232.028 179.837 231.363 178.839 230.364 178.839H199.677C199.078 178.839 198.545 179.238 198.345 179.771L189.891 203.003Z",
    fill: "#21323F"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M169.855 205.066H203.405C204.004 205.066 204.47 204.6 204.47 204.001C204.47 203.402 204.004 202.936 203.405 202.936H169.855C169.256 202.936 168.79 203.402 168.79 204.001C168.79 204.6 169.322 205.066 169.855 205.066Z",
    fill: "#21323F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M190.024 205.066H223.574C224.174 205.066 224.639 204.6 224.639 204.001C224.639 203.402 224.174 202.936 223.574 202.936H190.024C189.425 202.936 188.959 203.402 188.959 204.001C188.959 204.6 189.425 205.066 190.024 205.066Z",
    fill: "#21323F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiverse);
export default __webpack_public_path__ + "static/media/diverse.8d0a657188c0a3de8952a7a80f4c0737.svg";
export { ForwardRef as ReactComponent };